import WorkcellHeader from './WorkcellHeader'

export default WorkcellHeader
